import { FC, Fragment, useReducer } from 'react';

import { SquarePen } from 'lucide-react';
import { omit } from 'remeda';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { SlotForm } from '../../slotFormDialog/form';
import { SlotFormDialog } from '../../slotFormDialog/SlotFormDialog';

import { slotService } from 'v2/api/slotService';
import { SlotModel } from 'v2/types/SlotModel';
import { handleHttpError } from 'v2/utils';

interface SlotTableActionsColumnProps {
  slot: SlotModel;
  onRevalidate: VoidFunction;
}

export const SlotTableActionsColumn: FC<SlotTableActionsColumnProps> = ({ slot, onRevalidate }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation(['updateSlot', slot.id], slotService.updateSlot, {
    onSuccess: () => {
      onRevalidate();
      toast.success('The slot has been successfully updated');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: SlotForm, resetForm: VoidFunction) => {
    trigger(values).then(() => resetForm());
  };

  return (
    <Fragment>
      <Tooltip title="Edit" placement="top">
        <IconButton onClick={setOpen} color="warning">
          <SquarePen width={22} height={22} />
        </IconButton>
      </Tooltip>

      <SlotFormDialog
        title="Edit Slot"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={omit(slot, ['id'])}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
